import { AsyncPipe, NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { FormlyModule } from "@ngx-formly/core";
import { MessageModule } from "primeng-v17/message";
import { PanelModule } from "primeng-v17/panel";
import { TabViewModule } from "primeng-v17/tabview";
import { FormElementMapModule } from "../../shared/from-element-map/form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";
import { NewUiFormlyRepeatTabsComponent } from "./new-ui-formly-repeat-tabs.component";

@Component({
  selector: "app-formly-repeat-tabs",
  templateUrl: "./formly-repeat-tabs.component.html",
  styleUrl: "./formly-repeat-tabs.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    FormlyModule,
    MessageModule,
    Button,
    FormElementMapModule,
    TabViewModule,
    NgFor,
    PanelModule,
    TestIdDirective,
    AsyncPipe,
  ],
})
export class FormlyRepeatTabsComponent extends NewUiFormlyRepeatTabsComponent {}
